var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 280,
    viewBox: "0 0 424 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.124 132L205.248 279.5H0L42.124 132Z",
    fill: "#4C1D95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.124 132L109 188L53 169L21 205L42.124 132Z",
    fill: "#F5F3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 66L285.645 276.25H48.3545L128 66Z",
    fill: "#4C1D95"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127 63L159 100L205 160L148 125L139 168L127 138L88 171L127 63Z",
    fill: "#F5F3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M328 138L352.727 279.5H155.273L328 138Z",
    fill: "#4C1D95"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328 138L340 201L315 171L272.5 182L328 138Z",
    fill: "#F5F3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232 0L300.454 279.5H103L232 0Z",
    fill: "#4C1D95"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232 0L257.527 104L232 77L215 104V70L181 110L232 0Z",
    fill: "#F5F3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M371.304 157L424 280H272L371.304 157Z",
    fill: "#4C1D95"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M371.304 157L391 202.5L371.304 177L338.5 198L371.304 157Z",
    fill: "#F5F3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316 186L307.441 263H223L316 186Z",
    fill: "#5B21B6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240 118L285 263H223V176L240 118Z",
    fill: "#5B21B6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M354.598 198L391 263H286L354.598 198Z",
    fill: "#5B21B6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51 187L74 222L188 265L43 260L51 187Z",
    fill: "#5B21B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a51015f7917d32724c2dd1eab5e8f7d4.svg";
export { ForwardRef as ReactComponent };